import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { deletePersonalWheel, selectUserWheels, setActiveWheel, setMode } from '../../../../state';
import { take } from 'rxjs';
import { CreateWheelModalComponent } from '../create-wheel-modal/create-wheel-modal.component';
import { ConfirmationDialogComponent } from '../../../../ui/dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { mapActiveWheel } from '../../../../utils/mappers/active-wheel.mapper';

@Component({
  selector: 'wil-admin-tab-wheel-card',
  standalone: true,
  imports: [],
  templateUrl: './admin-tab-wheel-card.component.html',
  styleUrl: './admin-tab-wheel-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminTabWheelCardComponent {
  private readonly dialog = inject(MatDialog);
  private readonly store = inject(Store);

  public readonly wheel = input.required<WheelVersion>();
  public readonly accountId = input.required<string | null>();

  public getCategoryCount(wheel: WheelVersion): number {
    return wheel.categorySnapshots?.length;
  }

  public getWheelColors(wheel: WheelVersion): readonly string[] {
    return wheel.categorySnapshots.map((category) => category.color || '#e0e0e0');
  }

  public onEditWheel(): void {
    this.store
      .select(selectUserWheels)
      .pipe(take(1))
      .subscribe((wheels) => {
        const wheel = mapActiveWheel(wheels, this.wheel().id);

        // todo don't fail silently
        if (!wheel?.name) return;

        this.store.dispatch(setActiveWheel({ wheel: wheel }));
        this.store.dispatch(setMode({ mode: 'edit' }));

        this.dialog.open(CreateWheelModalComponent, {
          width: '98vw',
          maxHeight: '98vh',
          disableClose: false,
          hasBackdrop: true,
          panelClass: 'edit-wheel-modal-panel',
          data: { wheelId: this.wheel().id, name: wheel.name },
        });
      });
  }

  public onDeleteWheelClick(): void {
    const dialogData: ConfirmationDialogData = {
      title: 'warning',
      message: 'deleteWheelWarning',
      confirmText: 'ok',
      cancelText: 'cancel',
    };

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData,
      width: '400px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;

      this.store.dispatch(deletePersonalWheel({ wheelId: this.wheel().id }));
    });
  }
}
